module.exports = __webpack_public_path__ + "img/A84337_611D18_3F110F_7C2A22-256px.c0d23714.png";